import { Board } from '~/components/Shared/Layout/Board/Board';
import PriceListTable from './PriceListTable/PriceListTable';
import { useState } from 'react';
import styles from './AssetPriceList.module.scss';
import { useQuery } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';
import { useToastError } from '~/utils/useToastError';

const AssetPriceList = ({ assetId }: { assetId: string | undefined }) => {
  const toastError = useToastError();
  const [sort, setSort] = useState({
    field: '',
    direction: '',
  });

  const { data } = useQuery({
    queryFn: async () => {
      const { data } = await instance.get(`admin/asset-price-lists/${assetId}`);
      return data;
    },
    queryKey: ['price-list', assetId],
    onError: error => {
      toastError(error);
    },
  });

  const priceLists = data?.map((item: string, idx: number) => {
    return { id: idx, name: item };
  });

  const deletePrice = (id: number) => {
    return id;
  };

  return (
    <Board classNames={styles.board}>
      <PriceListTable
        data={priceLists}
        sort={sort}
        setSort={setSort}
        deletePrice={id => deletePrice(id)}
      />
    </Board>
  );
};

export default AssetPriceList;
